// @ts-nocheck
export const selectCampaigns = state => state.campaign.campaigns;
export const selectCampaignDetails = state => state.campaign.campaignDetails;
export const selectCampaignSeries = state => state.campaign.campaignSeries?.series;
export const selectCampaignProducts = state => state.campaign.products?.products;
export const selectCampaignSeriesSegments = state => state.campaign.seriesSegments;
export const selectCurrentPage = state => state.campaign.page;
